<page-load-header *ngIf="!initialized"></page-load-header>

<div *ngIf="initialized" class="space-1">
  <h4>Teaching CEUs</h4>

  <div *ngIf="events && events.length == 0" class="row no-gutters no-candidates" style="min-height: 200px">
    <div class="col-sm-12 my-auto">
      <h1><i class="fas fa-file-certificate"></i></h1>
      <h4>No CEUs Yet</h4>
      <p>
        You haven't earned any teaching CEUs yet.
        <br />
        <strong class="text-dark">If you feel like you are missing something, make sure you are logged in with the correct email.</strong>
      </p>
    </div>
  </div>

  <div class="card mb-2" *ngFor="let evnt of events">
    <div class="card-body p-4">
      <div class="row">
        <div class="col-md-10">
          <h1 class="h5 mb-1">
            <a [routerLink]="[evnt.id, 'addEdit']">{{ evnt.title }}</a>
          </h1>
        </div>
        <div class="col-md-2">
          <div class="text-right">
            <div class="position-relative d-inline-block text-right">
              <div class="dropdown">
                <button class="btn btn-xs btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Actions</button>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                  <a class="dropdown-item" [routerLink]="[evnt.id]">View Certificates</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <span>
            <a class="mr-2" [routerLink]="['/', evnt.id, 'registration']">{{ evnt.instructor.fullName }}</a>
            <a class="mr-2" *ngFor="let coInstructor of evnt.coInstructors" [routerLink]="['/', evnt.id, 'registration']">{{ coInstructor.fullName }}</a>
          </span>

          <div class="d-md-flex align-items-md-top">
            <div class="u-ver-divider u-ver-divider--none-md pr-4 mb-3 mb-md-0 mr-4">
              <h2 class="small text-secondary mb-0">Date <i [pTooltip]="'This is the date you participated in the event.'" class="text-admin-primary fas fa-question-circle"></i></h2>
              <div *ngIf="evnt.ceuParticipationDate">
                <small class="fas fa-calendar-alt text-secondary align-middle mr-1"></small>
                <span class="align-middle">{{ evnt.ceuParticipationDate | date: 'short' }} </span>
              </div>
              <div *ngIf="!evnt.ceuParticipationDate">
                <span class="align-middle">N/A </span>
              </div>
            </div>
            <div class="u-ver-divider u-ver-divider--none-md pr-4 mb-3 mb-md-0 mr-4">
              <h2 class="small text-secondary mb-0">CEUs</h2>
              <span *ngIf="(evnt.ceus | ceuCount) > 0">{{ evnt.ceus | ceuDisplay }}</span>
              <span *ngIf="(evnt.ceus | ceuCount) == 0">0</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
